import { render } from "./NewsBadge.vue?vue&type=template&id=38727518&scoped=true"
import script from "./NewsBadge.vue?vue&type=script&lang=js"
export * from "./NewsBadge.vue?vue&type=script&lang=js"

import "./NewsBadge.vue?vue&type=style&index=0&id=38727518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38727518"]])

export default __exports__